<script setup>
import Card from '@/components/shared/page/Card.vue'

//Props
defineProps({
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <Card :class="$style.card">
    <span><slot>{{ text }}</slot></span>
  </Card>
</template>

<style module lang="scss">
.card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-text-muted);
  text-align: center;
  border: none;
}
</style>
